import React from 'react';
import { MenuItem, Stack, TextField } from '@mui/material';
import { FormDrawer } from '../../../../../components/ui';
import { FORM_STUDIO_COPY } from '../../constants/formStudioConfig';
import LeadSummarySchedulerForm from './LeadSummarySchedulerForm';
import UpdateStatusSchedulerForm from './UpdateStatusSchedulerForm';

const ACTION_TYPES = [
  { value: 'update_status', label: 'Update status' },
  { value: 'send_lead_summary', label: 'Send lead summary' },
];

export default function SchedulerEditorDrawer({
  open,
  form,
  formId,
  workspaceId,
  organisationId,
  isSaving = false,
  onClose,
  onChange,
  onSubmit,
}) {
  const copy = FORM_STUDIO_COPY.automations.scheduled;

  return (
    <FormDrawer
      open={open}
      onClose={onClose}
      title={form?.scheduler_id ? copy.editTitle : copy.createTitle}
      submitLabel={copy.saveLabel}
      onSubmit={onSubmit}
      isSubmitting={isSaving}
    >
      <Stack spacing={2}>
        <TextField
          select
          label={copy.actionLabel}
          size="small"
          fullWidth
          value={form?.action || 'update_status'}
          onChange={(event) => onChange?.({ ...form, action: event.target.value })}
        >
          {ACTION_TYPES.map((action) => (
            <MenuItem key={action.value} value={action.value}>
              {action.label}
            </MenuItem>
          ))}
        </TextField>

        {form?.action === 'send_lead_summary' ? (
          <LeadSummarySchedulerForm
            form={form}
            onChange={onChange}
            organisationId={organisationId}
          />
        ) : (
          <UpdateStatusSchedulerForm form={form} formId={formId} onChange={onChange} />
        )}
      </Stack>
    </FormDrawer>
  );
}
